import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";
import { IconButton, DropdownItem } from "@similarweb/ui-components";

export const StyledDDContainer = styled.div`
    position: relative;

    & .DropdownContent-container {
        padding: 8px 0;

        transform: translate(8px, -5px);
    }
`;

const StyledDropdownButton = styled(IconButton)`
    & .SWReactIcons,
    &:hover .SWReactIcons {
        & svg path {
            fill: ${colorsPalettes.blue["400"]};
        }
    }
`;

export const StyledDropdownItem = styled(DropdownItem)<{ disabled?: boolean }>`
    ${mixins.setFontVariant("input2")};

    color: ${({ disabled }) => !disabled && colorsPalettes.carbon["500"]};
`;
